module.exports = __webpack_public_path__ + "static/media/RP-49.4f786311.pdf";